// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import InfoItem from './InfoItem'
import CompanyAddress from './CompanyAddress'
import { StatusIcon } from './styles'

const CompanyInfo = ({ company, idRoot }) => (
  <div className={'company-info'}>
    <InfoItem
      id={`${idRoot}-companyName`}
      label={'Company Name'}
      value={company.companyName} />
    <InfoItem
      id={`${idRoot}-companyStatus`}
      label={'Active'}
      value={(
        <StatusIcon active={company.companyStatus} />
      )} />
    <InfoItem
      id={`${idRoot}-dbaName`}
      label={'dba'}
      value={company.dbaName} />
    <InfoItem
      id={`${idRoot}-frn`}
      label={'FRN'}
      value={company.frn.join(', ')} />
    <InfoItem
      id={`${idRoot}-service`}
      label={'Service'}
      value={company.services.join(', ')} />
    <InfoItem
      id={`${idRoot}-companyType`}
      label={'Type'}
      value={(
        <>
          {
            company.companyType.map(d => (
              <span key={d.companyTypeId}>
                {`${d.companyTypeCode} - ${d.companyTypeName}`}
              </span>
            ))
          }
        </>
      )} />
    <InfoItem
      id={`${idRoot}-url`}
      label={'URL'}
      value={(
        company.url &&
        <a
          href={company.url}
          rel={'noopener noreferrer'}
          target={'_blank'}>
          {company.url}
        </a>
      )} />
    <InfoItem
      id={`${idRoot}-address`}
      label={(
        <strong>
          {
            company.companyAddress.length === 1
              ? 'Address'
              : 'Addresses'
          }
        </strong>
      )}
      value={(
        company.companyAddress.map((d, i) => (
          <CompanyAddress
            key={i}
            address={d}
            idRoot={`${idRoot}-address-${i}`} />
        ))
      )} />
  </div>
)

CompanyInfo.propTypes = {
  company: object.isRequired,
  idRoot: string.isRequired,
}

export default CompanyInfo
